import React, { useState, useEffect } from 'react';
import { Alert, message, Switch } from 'antd';
import Container from '@/components/Container';
import {
  getPrivateSettings,
  openVerification,
  updatePassword,
  closeVerification,
} from '@/services/salary/privateSettings';
import OpenPwdModal from './components/OpenPwdModal';
import UpdatePwdModal from './components/UpdatePwdModal';
import ClosePwdModal from './components/ClosePwdModal';
import PwdRow from './components/PwdRow';
import { VERIFY_PWD_OPEN } from '../constants';
import styles from './index.less';

const PrivateSettings = () => {
  const [switchOpen, setSwitchOpen] = useState(false);
  const [openVisible, setOpenVisible] = useState(false);
  const [updateVisible, setUpdateVisible] = useState(false);
  const [closeVisible, setCloseVisible] = useState(false);
  useEffect(() => {
    const fetch = async () => {
      try {
        const { statusCode } = await getPrivateSettings();
        setSwitchOpen(statusCode === VERIFY_PWD_OPEN);
      } catch (e) {
        console.error(e);
      }
    }
    fetch();
  }, []);
  const handleOpenVisible = flag => () => {
    if (switchOpen) {
      setCloseVisible(flag);
    } else {
      setOpenVisible(flag);
    }
  };
  // 确认开启密码
  const handleOpen = async params => {
    try {
      await openVerification(params);
      message.success('设置成功');
      handleOpenVisible()();
      setSwitchOpen(true);
    } catch (e) {
      console.error(e);
    }
  };
  // 修改密码弹窗
  const handleUpdateVisible = flag => () => {
    setUpdateVisible(flag);
  };
  // 确认修改密码
  const handleUpdate = async params => {
    try {
      await updatePassword(params);
      message.success('修改成功');
      handleUpdateVisible()();
    } catch (e) {
      console.error(e);
    }
  };
  // 关闭密码弹窗
  const handleCloseVisible = flag => () => {
    setCloseVisible(flag);
  };
  // 确认关闭
  const handleClose = async params => {
    try {
      await closeVerification(params);
      message.success('关闭成功');
      handleCloseVisible()();
      setSwitchOpen(false);
    } catch (e) {
      console.error(e);
    }
  }

  return (
    <Container breStates isSplitBar>
      <div className={styles['initial-tips']}>
        <Alert
          type="info"
          message="1.开启工资条管理加密查看权限后，工资条管理员只有在正确输入密码后才可查看已发布的工资条内容；
2.密码连续10次输入有误当天将自动锁定工资条管理界面，可反馈本组织超级管理员初始化关闭重置或者解除本次页面锁定状态。"
          showIcon
        />
      </div>
      <div className={styles['password-row']}>
        <span>工资条管理加密查看权限：</span>
        <Switch
          checkedChildren="开"
          unCheckedChildren="关"
          checked={switchOpen}
          onChange={handleOpenVisible(true)}
        />
      </div>
      {openVisible && (
        <OpenPwdModal
          onOk={handleOpen}
          onCancel={handleOpenVisible(false)}
        />
      )}
      {switchOpen && <PwdRow onClick={handleUpdateVisible(true)} />}
      {updateVisible && (
        <UpdatePwdModal
          onOk={handleUpdate}
          onCancel={handleUpdateVisible(false)}
        />
      )}
      {closeVisible && (
        <ClosePwdModal
          onOk={handleClose}
          onCancel={handleCloseVisible(false)}
        />
      )}
    </Container>
  );
};

export default PrivateSettings;
